import Row from '@components/row'
import {
  ActionButton,
  BookActions,
  BookCard,
  BookCategory,
  BookCover,
  BookSubtitle,
  BookTitle,
  BookWrapper,
} from '../style'
import SvgImage from '@components/svg'
import Column from '@components/column'
import useWindowSize from '@hooks/useWindow'

const BookInfo = ({ book, handleEdit, handleDelete, handleView }: any) => {
  const { width } = useWindowSize()
  const isMobile = width < 1024

  return (
    <>
      <BookCard
        onClick={(e) => {
          e.stopPropagation()
          handleView(book)
        }}
      >
        <Row colGap={10} styleRow={{ width: '100%' }}>
          <BookWrapper>
            <BookCover
              src={`${process.env.BUCKET_URL}/${book?.coverImage}`}
              alt={book?.name}
            />
          </BookWrapper>

          <Column styleColumn={{ width: '100%' }} rowGap={4}>
            <BookTitle size={16} weigth={400}>
              {book?.name}
            </BookTitle>
            <BookSubtitle tc="greyText" size={14}>
              {book?.author}
            </BookSubtitle>
            <BookCategory>{book?.categoryData?.name}</BookCategory>
            {!!isMobile && (
              <Row styleRow={{ marginTop: 'auto' }}>
                <BookActions>
                  <ActionButton
                    onClick={(e) => {
                      e.stopPropagation()
                      handleEdit(book)
                    }}
                  >
                    <SvgImage src="eye" size={24} color="primary" />
                  </ActionButton>
                  <ActionButton
                    onClick={(e) => {
                      e.stopPropagation()
                      handleEdit(book)
                    }}
                  >
                    <SvgImage src="editIcon" size={24} />
                  </ActionButton>
                  <ActionButton
                    onClick={(e) => {
                      e.stopPropagation()
                      handleDelete(book.id)
                    }}
                  >
                    <SvgImage src="deleteIcon" size={24} />
                  </ActionButton>
                </BookActions>
              </Row>
            )}
          </Column>
        </Row>
        {!isMobile && (
          <BookActions>
            <ActionButton
              onClick={(e) => {
                e.stopPropagation()
                handleView(book)
              }}
            >
              <SvgImage src="eye" size={24} color="primary" />
            </ActionButton>
            <ActionButton
              onClick={(e) => {
                e.stopPropagation()
                handleEdit(book)
              }}
            >
              <SvgImage src="editIcon" size={24} />
            </ActionButton>
            <ActionButton
              onClick={(e) => {
                e.stopPropagation()
                handleDelete(book.id)
              }}
            >
              <SvgImage src="deleteIcon" size={24} />
            </ActionButton>
          </BookActions>
        )}
      </BookCard>
    </>
  )
}

export default BookInfo
